export const TeamLiveScheduleRoutes = [
    {
        "url": "/schedule?user&openSidebar&openEfficiencyBudgetModal&date&openScheduleGraph",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@hmodules/team-live/schedule/full_burden/team-live-full_burden.module");
                }
            }
        ]
    },
    {
        "url": "/print-schedule",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@hmodules/team-live/schedule/full_burden/team-live-full_burden.module");
                }
            }
        ]
    }
];
//# sourceMappingURL=team-live_schedule.routes.js.map